export default {
  name: 'Content section - 9',
  tab: 'content',
  type: 'content-side-by-syde-section',
  content: {
    title: 'Side by side content section',
    introtext:
      '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p><p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>',
    image: '/storage/media/samples/pexels-fauxels-3228749.jpg',
    buttons: '[]'
  },
  design: {
    'background-color': 'var(--background-color)',
    'background-image': '',
    'background-image-tablet': '',
    'background-image-mobile': '',
    'parallax-background-image': '0',
    'custom-padding': '1',
    'padding-top': '100px',
    'padding-bottom': '100px',
    'title-color': 'inherit',
    'title-font-weight': 'var(--title-font-weight)',
    'title-tag': 'h2',
    'introtext-color': 'inherit'
  },
  layout: {
    'content-container-fluid': '0',
    container: '1',
    'content-container-size': 'xl',
    'content-horizontal-alignment': 'start',
    'content-vertical-alignment': 'center',
    'image-size': 'lg',
    'image-position': 'left',
    'content-box': '0',
    'content-box-color': 'black',
    'content-box-padding': '30px',
    'content-box-opacity': '0.5',
    'content-box-elevation': '0',
    'content-box-rounded': '0'
  },
  advanced: {}
}
